import { useAtom } from 'jotai'

import { sidePanelStore } from 'src/stores/sidePanelStore'

export const useSidePanelStore = () => {
  const [sidePanelStoreValue, setSidePanelStoreValue] = useAtom(sidePanelStore.state)

  return {
    sidePanelStoreValue,
    setSidePanelStoreValue,
  }
}
